import LineGradient from "../components/LineGradient";
import { motion } from "framer-motion";

const Skills = () => {
  return (
    <section id="skills" className="pt-32 pb-16">
      {/* HEADING */}
      <motion.div
        className="md:w-1/3 text-center md:text-left"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, x: -50 },
          visible: { opacity: 1, x: 0 },
        }}
      >
        <p className="font-playfair font-semibold text-4xl mb-5 text-red">
          MY SKILLS
        </p>
        <LineGradient width="mx-auto w-2/5" />
        <p className="mt-10">
          These are the Programming languages, Frameworks, Libraries, databases and other technologies I have worked on and have some experience on this.
        </p>
      </motion.div>

      {/* SKILLS */}
      <div className="md:flex md:justify-between gap-8">
        <motion.div
          className="mx-auto relative bg-blue max-w-[500px] h-[450px] flex flex-col justify-end p-10 mt-20
          before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6 }}
          variants={{
            hidden: { opacity: 0, scale: 0.8 },
            visible: { opacity: 1, scale: 1 },
          }}
        >
          <p className="font-playfair text-4xl mb-5">Programming Languages</p>
          <hr />
          <p className="text-center text-xl m-3">
            HTML 5
          </p>
          <p className="text-center text-xl m-3">
            CSS 3
          </p>
          <p className="text-center text-xl m-3">
            JavaScript
          </p>
          <p className="text-center text-xl m-3">
            TypeScript
          </p>
          <p className="text-center text-xl m-3">
            Python
          </p>
          <p className="text-center text-xl m-3">
            C++
          </p>

        </motion.div>

        <motion.div
          className="mx-auto relative bg-red max-w-[500px] h-[450px] flex flex-col justify-end p-10 mt-20
          before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6 }}
          variants={{
            hidden: { opacity: 0, scale: 0.8 },
            visible: { opacity: 1, scale: 1 },
          }}
        >
          <p className="font-playfair text-4xl mb-4 ">Libraries , Frameworks</p>
          <hr />
          <p className="text-center text-xl m-3">
            React js
          </p>
          <p className="text-center text-xl m-3">
            Redux
          </p>
          <p className="text-center text-xl m-3">
            GraphQl
          </p>
          <p className="text-center text-xl m-3">
            Material UI
          </p>
          <p className="text-center text-xl m-3">
            Express js
          </p>
          <p className="text-center text-xl m-3">
            Node js
          </p>

        </motion.div>

        <motion.div
          className="mx-auto relative bg-yellow max-w-[500px] h-[450px] flex flex-col justify-end p-10 mt-20
          before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2"
          style={{ color: 'black' }}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6 }}
          variants={{
            hidden: { opacity: 0, scale: 0.8 },
            visible: { opacity: 1, scale: 1 },
          }}
        >
          <p className="font-playfair text-4xl mb-5">Tools for Programming</p>
          <hr />
          <p className="text-center text-xl m-3">
            Git
          </p>
          <p className="text-center text-xl m-3">
            Github
          </p>
          <p className="text-center text-xl m-3">
            Mongodb
          </p>
          <p className="text-center text-xl m-3">
            Word
          </p>
          <p className="text-center text-xl m-3">
            Excel
          </p>
          <p className="text-center text-xl m-3">
            Powerpoint
          </p>

        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
